// API configuration
// Local dev: Spring Boot on http://localhost:8080
// Production (Vercel): uses /api/send-email — set SMTP_PASS in Vercel env vars
const isDev = process.env.NODE_ENV === 'development';
const configuredApiUrl = process.env.REACT_APP_API_URL || '';
const isLocalhostApiUrl = /localhost|127\.0\.0\.1/i.test(configuredApiUrl);

const API_BASE_URL = isDev
  ? (configuredApiUrl || 'http://localhost:8080')
  : (configuredApiUrl && !isLocalhostApiUrl ? configuredApiUrl : '');

export const API_ENDPOINTS = {
  CONTACT: API_BASE_URL ? `${API_BASE_URL}/api/contact` : '/api/send-email',
  CONSULTATION: API_BASE_URL ? `${API_BASE_URL}/api/consultation` : '/api/send-email',
};

export async function submitForm(url, body, timeoutMs = 15000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal: controller.signal,
    });

    let data = {};
    try {
      data = await response.json();
    } catch {
      data = { error: 'Invalid response from server.' };
    }

    return { ok: response.ok, data };
  } catch (error) {
    if (error.name === 'AbortError') {
      return {
        ok: false,
        data: {
          error: 'Request timed out. Make sure the backend is running on port 8080 (mvn spring-boot:run).',
        },
      };
    }

    return {
      ok: false,
      data: {
        error: 'Network error. Start the backend from the backend folder: mvn spring-boot:run',
      },
    };
  } finally {
    clearTimeout(timeoutId);
  }
}
